'use client';

/*
 * Global constant
 * */
var _a;
var HRINSIDER_ATTACH_RESUME_LINK = 'https://www.vietnamworks.com/hrinsider/ho-so-ung-tuyen.html';
var LIMIT_CHARACTERS = 5000;
var DEFAULT_ALLOW_EXT = ['.doc', '.docx', '.pdf'];
var MAX_NUMBER_OF_CV = 3;
var IS_REQUIRED_COVER_LETTER = 1;
var IS_RESUME_ATTACHMENT = 1;
var HTTP_CODE_SUCCESS = 200;
var DEFAULT_COMPANY_LOGO = 'https://images.vietnamworks.com/img/company-default-logo.svg';
var INTERN_LEVEL = 1;
var FRESHER_LEVEL = 8;
var MANAGER_LEVEL = 7;
var DIRECTOR_LEVEL = 3;
var MODAL_SCROLLABLE_BODY_MODAL = 'SCROLLABLE_BODY_MODAL';
/*
 * Styles constant
 * */
var LIMIT_MODAL_HEIGHT = 350;
var COLLAPSE_ANIMATION_DURATION = 250;
/*
 * Application information constant
 * */
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var JOB_TITLE_LENGTH = 80;
var NAME_LENGTH = 50;
/*
 * Working preference constant
 * */
var DEFAULT_MIN_SALARY = 0;
var DEFAULT_MAX_SALARY = 500000;
var INTERNATIONAL_CITY_ID = 70;
var MEKONG_CITY_ID = 71;
var OTHER_CITY_ID = 66;
var VIETNAM_COUNTRY_ID = 1;
var META_API_LINK = 'meta/v1.0/international-phone-number';
var nationalityList = function (langCode) {
    var nationalityList = {
        en: [
            { id: 1, name: 'Local Vietnamese' },
            { id: 2, name: 'Foreigner' }
        ],
        vi: [
            { id: 1, name: 'Người Việt Nam' },
            { id: 2, name: 'Người nước ngoài' }
        ]
    };
    return nationalityList[langCode];
};
var educations = [
    { id: 2, name: 'Trung học', nameEn: 'High school' },
    { id: 3, name: 'Trung cấp', nameEn: "Associate's degree" },
    { id: 12, name: 'Cao đẳng', nameEn: 'College' },
    { id: 4, name: 'Cử nhân', nameEn: 'Bachelors' },
    { id: 5, name: 'Thạc sĩ', nameEn: 'Masters' },
    { id: 6, name: 'Tiến sĩ', nameEn: 'Doctorate' },
    { id: 11, name: 'Khác', nameEn: 'Others' }
];
/*
 * Form control constants
 * */
var EFormFieldIDs;
(function (EFormFieldIDs) {
    EFormFieldIDs["yourResume"] = "YOUR_RESUME";
    EFormFieldIDs["coverLetter"] = "COVER_LETTER";
    EFormFieldIDs["applicationInfomation"] = "APPLICATION_INFOMATION";
    EFormFieldIDs["workingPreferences"] = "WORKING_PREFERENCES";
})(EFormFieldIDs || (EFormFieldIDs = {}));
var FORM_FIELD_ERROR_CONTROL = (_a = {},
    _a[EFormFieldIDs.yourResume] = new Set(['applyResume']),
    _a[EFormFieldIDs.coverLetter] = new Set(['coverLetter']),
    _a[EFormFieldIDs.applicationInfomation] = new Set([
        'firstName',
        'lastName',
        'jobTitle',
        'currentJobFunction',
        'currentIndustries',
        'currentSalary',
        'jobLevelId',
        'yearsExperience',
        'highestDegreeId',
        'phone',
        'birthday',
        'nationalityId',
        'genderId',
        'maritalStatusId',
        'levelLocations'
    ]),
    _a[EFormFieldIDs.workingPreferences] = new Set([
        'locations',
        'companyIndustries',
        'salary',
        'benefits',
        'jobFunction',
        'desiredJobLevelId'
    ]),
    _a);
var EResumeType;
(function (EResumeType) {
    EResumeType[EResumeType["ONLINE"] = 0] = "ONLINE";
    EResumeType[EResumeType["ATTACH"] = 1] = "ATTACH";
})(EResumeType || (EResumeType = {}));
var ALLOW_SEARCHABLE = 1;

export { ALLOW_SEARCHABLE, COLLAPSE_ANIMATION_DURATION, DEFAULT_ALLOW_EXT, DEFAULT_COMPANY_LOGO, DEFAULT_MAX_SALARY, DEFAULT_MIN_SALARY, DIRECTOR_LEVEL, EFormFieldIDs, EResumeType, FORM_FIELD_ERROR_CONTROL, FRESHER_ID, FRESHER_LEVEL, HRINSIDER_ATTACH_RESUME_LINK, HTTP_CODE_SUCCESS, INTERNATIONAL_CITY_ID, INTERNSHIP_ID, INTERN_LEVEL, IS_REQUIRED_COVER_LETTER, IS_RESUME_ATTACHMENT, JOB_TITLE_LENGTH, LIMIT_CHARACTERS, LIMIT_MODAL_HEIGHT, MANAGER_LEVEL, MAX_NUMBER_OF_CV, MEKONG_CITY_ID, META_API_LINK, MODAL_SCROLLABLE_BODY_MODAL, NAME_LENGTH, OTHER_CITY_ID, VIETNAM_COUNTRY_ID, educations, nationalityList };
//# sourceMappingURL=constants.js.map
